// src/sanityClient.ts
import { createClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

const projectId = process.env.REACT_APP_SANITY_PROJECT_ID;
const dataset = process.env.REACT_APP_SANITY_DATASET;
const token = process.env.REACT_APP_SANITY_TOKEN;

export const client = createClient({
  projectId,
  dataset,
  useCdn: false,
  apiVersion: "2023-07-17",
});

export const secureClient = createClient({
  projectId,
  dataset,
  token,
  useCdn: false,
  apiVersion: "2023-07-17",
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);
